import RoundButton from 'features/shared/components/buttons/RoundButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AccountRoleDTO from '../dtos/AccountRoleDTO';

interface Props {
  role: AccountRoleDTO;
  onDeleteClick?: (role: AccountRoleDTO) => void;
}

const AccountRole = ({ role, onDeleteClick }: Props) => {
  // tranlations
  const { t } = useTranslation("customer\\enums\\customerRole");

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        {t(role.role!)}
      </div>
      <div className="col-auto pl-3">
        {onDeleteClick !== undefined &&
          <RoundButton 
            icon="trash" 
            onClickHandler={() => onDeleteClick(role)}
          />
        }
      </div>
    </div>
  )
}

export default AccountRole;
